export const ADD_CART_ITEM = 'ADD_CART_ITEM';

/**
 * This action is used to add items to the cart state
 * @param {string} inventoryLevelId The inventoryLevelId to add to the cart
 * @param {number} quantity The quantity to add
 * @param {string} title The title of the variant
 * @param {string} imageUrl The URL of the product image
 * @param {string} price The price of the variant
 * @param {number} availableQuantity The quantity available of the variant
 * @param {boolean} availableForSale Determines whether the variant is available for sale or not
 * @param {string} sku The variant SKU
 * @param {string} handle The handle of the product
 * @param {boolean} bypassNegativeQuantity Whether or not to allow negative qty.
 * @returns An action object of the specified type and payload
 */

const addCartItem = (inventoryLevelId, quantity, title, imageUrl, price, availableQuantity, availableForSale, sku, handle, lineItemId, bypassNegativeQuantity) => {
    return {
        type: ADD_CART_ITEM,
        payload: {
            inventoryLevelId,
            title,
            imageUrl,
            quantity,
            price,
            availableQuantity,
            availableForSale,
            sku,
            handle,
            lineItemId,
            bypassNegativeQuantity,
        },
    };
};

export default addCartItem;